module.exports = __webpack_public_path__ + "static/media/banner-harineraanahuac.89e7c346.jpg";